module.exports = __webpack_public_path__ + "static/media/vintagegold1.da5157dc.PNG";